import { create } from 'axios';

import {
  GetAdminConsoleUserResponse,
  GetUserConsoleUserResponse,
  PostAdminRefreshTokenResponse,
  PostUserRefreshTokenResponse,
} from '@/shared/api/cloud/types';

export const instance = create({
  withCredentials: true,
});

export const getUserConsoleUser = () => {
  return instance.get<GetUserConsoleUserResponse>('/api/v1/saas/user');
};

export const getAdminConsoleUser = () => {
  return instance.get<GetAdminConsoleUserResponse>('/api/v1/user');
};

export const postUserRefreshToken = () => {
  return instance.post<PostUserRefreshTokenResponse>(
    '/api/v1/saas/auth/_refresh'
  );
};

export const postAdminRefreshToken = () => {
  return instance.post<PostAdminRefreshTokenResponse>(
    '/api/v1/users/auth/_refresh'
  );
};
